var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { createContext, useContext, useState, useEffect } from 'react';
import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import { compact } from 'lodash';
var OnboardingContext = createContext(undefined);
var ONBOARD_USER_MUTATION = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation OnboardUser($id: String!, $input: OnboardUserInput!) {\n    onboardUser(id: $id, input: $input)\n  }\n"], ["\n  mutation OnboardUser($id: String!, $input: OnboardUserInput!) {\n    onboardUser(id: $id, input: $input)\n  }\n"])));
export var OnboardingProvider = function (_a) {
  var verify = _a.verify,
    entityOnboardingViews = _a.entityOnboardingViews,
    children = _a.children;
  var _b = __read(useMutation(ONBOARD_USER_MUTATION), 2),
    onboardUser = _b[0],
    loading = _b[1].loading;
  // Local state bucket for the onboarding process.
  var _c = __read(useState({
      simpleSelections: {},
      junctionSelections: {},
      login: null,
      password: ''
    }), 2),
    onboardingState = _c[0],
    setOnboardingState = _c[1];
  var _d = __read(useState(0), 2),
    movingToStep = _d[0],
    setMovingToStep = _d[1];
  var _e = __read(useState(0), 2),
    currentStep = _e[0],
    setCurrentStep = _e[1];
  // Build the steps array. Used in OnboardingSteps component and passes the view into OnboardingView component
  // as user navigates through the onboarding process.
  var onboardingSteps = compact(__spreadArray(__spreadArray([], __read(entityOnboardingViews.map(function (view) {
    return {
      title: view.title,
      entityKey: view.hash,
      view: view
    };
  })), false), [{
    title: "Last step. Create new password",
    entityKey: "login",
    view: {}
  }], false));
  // Handle a generic selection for linkedMuliple entities.
  var handleItemSelection = function (entityKey, selection, expertiseLevel) {
    // Ignore special keys
    if (entityKey === 'login' || entityKey === 'password') return;
    setOnboardingState(function (prevState) {
      var _a, _b;
      if (expertiseLevel) {
        // --- Handle Junction Selection ---
        var currentJunctionGroup = prevState.junctionSelections[entityKey] || [];
        var levelEntry = currentJunctionGroup.find(function (entry) {
          return entry.levelOfExpertise.id === expertiseLevel.id;
        });
        var updatedJunctionGroup = void 0;
        if (!levelEntry) {
          // Level entry doesn't exist, create it and add the item
          levelEntry = {
            levelOfExpertise: expertiseLevel,
            items: [selection]
          };
          updatedJunctionGroup = __spreadArray(__spreadArray([], __read(currentJunctionGroup), false), [levelEntry], false);
        } else {
          // Level entry exists, toggle the item within its items array
          var itemIndex = levelEntry.items.findIndex(function (i) {
            return i.id === selection.id;
          });
          var updatedItems_1;
          if (itemIndex > -1) {
            // Remove item
            updatedItems_1 = levelEntry.items.filter(function (i) {
              return i.id !== selection.id;
            });
          } else {
            // Add item
            updatedItems_1 = __spreadArray(__spreadArray([], __read(levelEntry.items), false), [selection], false);
          }
          updatedJunctionGroup = currentJunctionGroup.map(function (entry) {
            return entry.levelOfExpertise.id === expertiseLevel.id ? __assign(__assign({}, entry), {
              items: updatedItems_1
            }) : entry;
          });
          // Optional: Filter out level entries with no items left
          updatedJunctionGroup = updatedJunctionGroup.filter(function (entry) {
            return entry.items.length > 0;
          });
        }
        return __assign(__assign({}, prevState), {
          junctionSelections: __assign(__assign({}, prevState.junctionSelections), (_a = {}, _a[entityKey] = updatedJunctionGroup, _a))
        });
      } else {
        // --- Handle Simple Selection ---
        var currentSimpleSelection = prevState.simpleSelections[entityKey] || [];
        var isSelected = currentSimpleSelection.some(function (item) {
          return item.id === selection.id;
        });
        var newSelection = void 0;
        if (isSelected) {
          newSelection = currentSimpleSelection.filter(function (item) {
            return item.id !== selection.id;
          });
        } else {
          newSelection = __spreadArray(__spreadArray([], __read(currentSimpleSelection), false), [selection], false);
        }
        return __assign(__assign({}, prevState), {
          simpleSelections: __assign(__assign({}, prevState.simpleSelections), (_b = {}, _b[entityKey] = newSelection, _b))
        });
      }
    });
  };
  // console.log('Onboarding state:', onboardingState);
  var onPasswordSubmit = function (newPassword) {
    setOnboardingState(function (prev) {
      return __assign(__assign({}, prev), {
        password: newPassword
      });
    });
  };
  // Transform the onboarding state into the format expected by the mutation.
  var transformOnboardingStateToInput = function (state) {
    var types = (state.simpleSelections['ProfileType'] || []).map(function (item) {
      return item.id;
    });
    var objectives = (state.simpleSelections['Objective'] || []).map(function (item) {
      return item.id;
    });
    // Add other simple selections here...
    var trendExpertise = (state.junctionSelections['TrendExpertise'] || []).map(function (entry) {
      return {
        levelOfExpertise: entry.levelOfExpertise.id,
        trends: entry.items.map(function (item) {
          return item.id;
        })
      };
    });
    // Add other junction selections here...
    return {
      types: types,
      objectives: objectives,
      trendExpertise: trendExpertise,
      // Add other selections here...
      password: state.password || ''
    };
  };
  useEffect(function () {
    var runOnboardUser = function () {
      return __awaiter(void 0, void 0, void 0, function () {
        var input;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              input = transformOnboardingStateToInput(onboardingState);
              return [4 /*yield*/, onboardUser({
                variables: {
                  id: verify,
                  input: input
                }
              })];
            case 1:
              _a.sent();
              return [2 /*return*/];
          }
        });
      });
    };
    if (onboardingState.password) {
      runOnboardUser();
    }
  }, [onboardingState.password]);
  // Navigation functions.
  var goToNextStep = function () {
    return setMovingToStep(function (prev) {
      return Math.min(prev + 1, onboardingSteps.length - 1);
    });
  };
  var goToPreviousStep = function () {
    return setMovingToStep(function (prev) {
      return Math.max(prev - 1, 0);
    });
  };
  var value = {
    onboardingState: onboardingState,
    currentStep: currentStep,
    movingToStep: movingToStep,
    onboardingSteps: onboardingSteps,
    handleItemSelection: handleItemSelection,
    goToNextStep: goToNextStep,
    goToPreviousStep: goToPreviousStep,
    onPasswordSubmit: onPasswordSubmit,
    setCurrentStep: setCurrentStep,
    setMovingToStep: setMovingToStep,
    loading: loading
  };
  return React.createElement(OnboardingContext.Provider, {
    value: value
  }, children);
};
export var useOnboarding = function () {
  var context = useContext(OnboardingContext);
  if (!context) {
    throw new Error('useOnboarding must be used within an OnboardingProvider');
  }
  return context;
};
var templateObject_1;